var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4286 15.75V17.1562C11.4286 17.6222 11.0448 18 10.5714 18H0.857143C0.38375 18 0 17.6222 0 17.1562V4.21875C0 3.75275 0.38375 3.375 0.857143 3.375H3.42857V13.7812C3.42857 14.8668 4.32575 15.75 5.42857 15.75H11.4286ZM11.4286 3.65625V0H5.42857C4.95518 0 4.57143 0.377754 4.57143 0.84375V13.7812C4.57143 14.2472 4.95518 14.625 5.42857 14.625H15.1429C15.6163 14.625 16 14.2472 16 13.7812V4.5H12.2857C11.8143 4.5 11.4286 4.12031 11.4286 3.65625ZM15.749 2.56539L13.3939 0.247113C13.2331 0.0888899 13.0151 1.16999e-06 12.7878 0L12.5714 0V3.375H16V3.16199C16 2.93822 15.9097 2.72362 15.749 2.56539Z",
    fill: "#00A0F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyBlue);
export default __webpack_public_path__ + "static/media/CopyBlue.bc11a67f9c18e905de30b5eed5c4f102.svg";
export { ForwardRef as ReactComponent };